import { useTranslation } from 'react-i18next';
import { ValidationError } from '../../apps/benefit/models/Errors';
import { cleanHTMLTags, getErrorMessage } from '../global/helpers';

interface ErrorViewerProps {
  errors?: ValidationError[];
}

//	TODO styles
export default function ErrorViewer(props: ErrorViewerProps) {
  const { errors } = props;
  const { t: translate } = useTranslation();

  if (!errors?.length) return null;

  return (
    <div className="control-error">
      {errors.map(e => {
        const message = getErrorMessage(e, translate);
        return e.severity === 'error' ? (
          <Error key={e.code} message={cleanHTMLTags(message)} />
        ) : (
          <Warning key={e.code} message={cleanHTMLTags(message)} />
        );
      })}
    </div>
  );
}

const Error = (props: { message: string }) => {
  const { message } = props;
  return <div className="control-error">{message}</div>;
};

const Warning = (props: { message: string }) => {
  const { message } = props;
  return <div className="control-warning">{message}</div>;
};
